module.exports = __webpack_public_path__ + "img/max.af00756f.jpg";